import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MarkdownViewerComponent } from '@examdojo/ui/markdown-viewer';

@Component({
  selector: 'dojo-markscheme-note',
  imports: [MarkdownViewerComponent],
  template: `
    <div class="align-center flex justify-start gap-2 rounded-[8px] border border-neutral-200 px-3 py-2">
      <div class="text-primary text-md flex self-start font-semibold leading-7">Note:</div>
      <dojo-markdown-viewer [content]="note" />
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarkschemeNoteComponent {
  @Input({ required: true }) note!: string;
}
